






































































































































































































































































































































































































































































































































































































































































































































































































import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { Vue, Component } from 'vue-property-decorator'
import store from '@/services/store';
import { Ax } from '@/utils';
import { cloneDeep } from 'lodash';
import VueElementLoading from 'vue-element-loading';
import Datepicker from "vue2-datepicker"
import { Agreement } from './types/Agreement';
import { Option } from './types/Option';
import moment from 'moment';
import i18nService from '@/services/i18n';

const budgetLoanModuleCode = '005.007'

interface TableColumnEntry {
    key: (keyof Agreement) | 'action' | 'section',
    label: string,
    class?: string
}

interface FilterOptions {
    agreementNumbers: Option<string>[]
    quarters: Option<number>[]
    budgetLevels: Option<number>[]
    creditors: Option<string>[]
    administrators: Option<string>[]
    contractors: Option<string>[]
    years: number[]
    statuses: Option<number>[]
    regions: Option<string>[]
}

interface FilterParameters {
    agreementNumbers: Option<string>[]
    quarter: Option<number> | null
    budgetLevel: Option<number> | null
    creditor: Option<string> | null
    administrator: Option<string> | null
    contractor: Option<string> | null
    year: number | null
    status: Option<number> | null
    region: Option<string> | null
}

interface CodeNameMap {
    administrator: Record<string, string>
    contractor: Record<string, string>
    creditor: Record<string, string>
    budgetLevel: Record<string, string>
}

interface HierarchyAgreement extends Agreement {
    collapse?: boolean
    children?: HierarchyAgreement[]
    additionals?: HierarchyAgreement[]
    remove?: boolean
}

interface LoanDirectionNode {
    id: number
    name: number
    collapse: boolean
    loanDirection: number
    amount: number
    leftAmount: number
    children: LoanPurposeNode[]

    tempAgreements: Map<string, HierarchyAgreement[]>
}

interface LoanPurposeNode {
    id: number
    name: number
    collapse: boolean
    loanPurpose: number
    amount: number
    leftAmount: number
    children: HierarchyAgreement[]
}

interface NameDict {
    section: Map<string, string>
    purpose: Map<string, string>
    status: Map<string, string>
    statusColor: Map<string, string>
}

interface NotificationForm {
    date: Date
    receivers: Option<string>[]
}

const quarterOptions = [
    { label: 'I', value: 1 },
    { label: 'II', value: 2 },
    { label: 'III', value: 3 },
    { label: 'IV', value: 4 }
]

const emptyParameters: FilterParameters = {
    agreementNumbers: [],
    quarter: null,
    budgetLevel: null,
    creditor: null,
    administrator: null,
    contractor: null,
    year: null,
    status: null,
    region: null
}

const resetFilterKey = 'eakimat_budget-loan_reset-filter'

@Component({
    name: 'budget-loan-table',
    components: {
        'loading': VueElementLoading,
        'date-picker': Datepicker
    }
})
export default class BudgetLoanTablePage extends Vue {
    // #region Data
    private availableForUser = true
    public tableData: LoanDirectionNode[] = []
    public collapseAll = true
    public nameDict: NameDict = {
        section: new Map(),
        purpose: new Map(),
        status: new Map(),
        statusColor: new Map()
    }
    public codeMap: CodeNameMap = {
        administrator: {},
        budgetLevel: {},
        contractor: {},
        creditor: {}
    }
    public filterParameters: FilterParameters = cloneDeep(emptyParameters)
    public filterTempParameters: FilterParameters = cloneDeep(emptyParameters)
    public filterOptions: FilterOptions = {
        agreementNumbers: [],
        quarters: [],
        budgetLevels: [],
        creditors: [],
        administrators: [],
        contractors: [],
        years: [],
        statuses: [],
        regions: []
    }
    private earliestYear: number | null = null
    private umConnected = true
    private userBudgetLevels = []
    private userRegions = []
    private userAccessLevel: number = -1
    public tableFields: TableColumnEntry[] = [
        {
            key: 'section',
            label: 'Раздел',
            class: 'toggle-show'
        },
        {
            key: 'loanPurpose',
            label: 'Цель',
            class: 'toggle-show'
        },
        {
            key: 'agreementNumber',
            label: 'Номер договора',
            class: 'toggle-show'
        },
        {
            key: 'signDate',
            label: 'Дата договора'
        },
        {
            key: 'budgetLevel',
            label: 'Уровень бюджета'
        },
        {
            key: 'creditor',
            label: 'Кредитор'
        },
        {
            key: 'administrator',
            label: 'Администратор'
        },
        {
            key: 'contractor',
            label: 'Заемщик'
        },
        {
            key: 'amount',
            label: 'Сумма договора'
        },
        {
            key: 'leftAmount',
            label: 'Текущий остаток суммы договора'
        },
        {
            key: 'statusId',
            label: 'Статус'
        },
        {
            key: 'returnDate',
            label: 'Срок возврата кредита'
        },
        {
            key: 'action',
            label: ''
        }
    ]
    public loading = false
    public notificationProcessloading = false
    public notificationForm: NotificationForm = {
        date: new Date(),
        receivers: []
    }
    private notificationFormModalVisibility = false
    public receiverOptions: Option<string>[] = []
    // endregion

    // #region Computed
    get userId(): string {
        return store.state.user.sub ?? ''
    }

    get isWriteAccess() {
        return this.userAccessLevel >= 2
    }

    get isAdminAccess() {
        return this.userAccessLevel >= 3
    }
    // #endregion

    async created() {
        if (!this.checkUserModuleAccessAndSetAccessLevel()) {
            this.availableForUser = false
            this.makeToast('Отсутствует доступ к режиму', 'Сообщение', 'danger')
            return
        }
        this.loading = true

        // Регионы пользователя
        await this.setUserRegions()

        // Уровень бюджета пользователя
        await this.setUserBudgetLevels()

        // 1. Загрузить маппинги код-название
        await this.loadAgreementsAndSetNameMappings()
        await this.loadValueNames()

        // 2. Загрузить default вариант для select-input-ов
        await this.setFilterParametersEmpty()
        await this.setFilterParametersFromQuery()

        // 3. Загрузить варианты для select-input-ов
        await this.setInitialFilterOptions()

        // 4. Загурзить договора
        await this.loadAgreementsFiltered()

        this.loading = false

        await this.setReceivers()
    }

    // #region Methods
    selectAllAgreements() {
        if (this.filterTempParameters.agreementNumbers.length === this.filterOptions.agreementNumbers.length) {
            this.filterTempParameters.agreementNumbers = []
        } else {
            this.filterTempParameters.agreementNumbers = this.filterOptions.agreementNumbers
        }
    }

    displayAgreementsCount(count: number){
        if (count === this.filterOptions.agreementNumbers.length) {
            return 'Все'
        } else {
            return `Выбрано: ${count}`
        }
    }

    onAgreementNumbersInput(options: Option<string>[]) {
        const selectedValues = options.map(it => it.value)
        this.filterOptions.agreementNumbers = [
            ...this.filterOptions.agreementNumbers.filter(it => selectedValues.includes(it.value)),
            ...this.filterOptions.agreementNumbers.filter(it => !selectedValues.includes(it.value)),
        ]
    }

    private async setReceivers() {
        const response = await fetch('/api/budget-loan/options/users')
        if (!response.ok) {
            this.makeToast('Не удалось загрузить пользователе', 'Ошибка', 'danger')
            return
        }

        const responseData: unknown[] = await response.json()

        const receiverOptions: Option<string>[] = responseData.map((it: any) => (
            {
                value: it.id,
                label: `${it.lastName} ${it.firstName}`
            }
        ))

        this.receiverOptions = receiverOptions
    }

    preventEvent(event: MouseEvent) {
        event.preventDefault()
    }

    async setFilterParametersFromQuery() {
        let tableQuery: string | null = null
        if (this.$route.params.tableQuery) {
            tableQuery = this.$route.params.tableQuery
        }

        if (tableQuery) {
            const parameters: FilterParameters = JSON.parse(tableQuery)

            if (parameters.budgetLevel) {
                this.onBudgetLevelChange(parameters.budgetLevel)
            }

            this.filterTempParameters = JSON.parse(tableQuery)
            this.filterParameters = JSON.parse(tableQuery)
        }
    }

    private checkUserModuleAccessAndSetAccessLevel() {
        for (const userModuleData of store.state.user.userModules) {
            if (userModuleData.modules === budgetLoanModuleCode) {
                // @ts-ignore
                this.userAccessLevel = userModuleData.access_level
                return true
            }
        }
        return false
    }

    private makeToast(message: string, title: string, variant: 'success' | 'danger' | 'info') {
        this.$bvToast.toast(message, {
            title: title,
            variant: variant,
            solid: true
        })
    }

    private async setUserRegions() {
        const response = await fetch(`/api-py/user-region/${this.userId}`)
        if (!response.ok) {
            this.makeToast('Не удалось загузить регионы пользователя', 'Ошибка', 'danger')
            return
        }
        const userRegionObjects = await response.json()
        const userRegions = userRegionObjects.map((it: any) => it.region)
        this.userRegions = userRegions
    }

    private async setUserBudgetLevels() {
        const response = await fetch(`/api-py/get-user-budget-level-only/${this.userId}`)
        const data = await response.json()
        const levels = data.map((it: any) => Number(it))
        this.userBudgetLevels = levels
    }

    private async loadAgreementsAndSetNameMappings() {
        const response = await fetch('/api/budget-loan')
        if (!response.ok) {
            this.makeToast('Не получилось загрузить договоры', 'Ошибка запроса', 'danger');
            return
        }

        const agreements = await response.json()
        this.setEarliestYear(agreements)
        this.loadCodeNameMappings(agreements)
    }

    private setEarliestYear(agreements: Agreement[]) {
        let tempYear = (new Date()).getFullYear()
        agreements.forEach(item => {
            const year = (new Date(item.signDate)).getFullYear()
            if (tempYear > year) {
                tempYear = year
            }
        })
        this.earliestYear = tempYear
    }

    private async loadCodeNameMappings(agreements: Agreement[]) {
        const codes: {
            budgetLevel: number[],
            administrator: string[],
            creditor: string[],
            contractor: string[]
        } = {
            budgetLevel: [],
            administrator: [],
            creditor: [],
            contractor: []
        }
        const mainAgreements = agreements.filter(item => item.type === 0)
        mainAgreements.forEach(it => {
            if (!codes.budgetLevel.includes(it.budgetLevel)) {
                codes.budgetLevel.push(it.budgetLevel)
            }
            if (!codes.administrator.includes(it.administrator)) {
                codes.administrator.push(it.administrator)
            }
            if (!codes.creditor.includes(it.creditor)) {
                codes.creditor.push(it.creditor)
            }
            if (!codes.contractor.includes(it.contractor)) {
                codes.contractor.push(it.contractor)
            }
        })
        const response = await fetch('/api/budget-loan/generate/code-name-map', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(codes)
        })

        const data = await response.json()
        this.codeMap = data
    }

    private async loadValueNames() {
        const response = await fetch('/api/dict/bc_section')
        if (response.ok) {
            const sections = await response.json()
            const sectionMap = new Map<string, string>()
            sections.forEach((it: any) => {
                sectionMap.set(it.code, `${it.section} ${it.nameRu}`)
            })
            this.nameDict.section = sectionMap
        } else {
            this.makeToast('Не получилось загрузить найменование секций', 'Ошибка запроса', 'danger');
        }

        const goalResponse = await fetch('/api/dict/bc_goal')
        if (goalResponse.ok) {
            const purposes = await goalResponse.json()
            const purposeMap = new Map()
            purposes.forEach((it: any) => {
                purposeMap.set(it.code, it.nameRu)
            })
            this.nameDict.purpose = purposeMap
        } else {
            this.makeToast('Не получилось загрузить найменование целей', 'Ошибка запроса', 'danger')
        }

        const statusResponse = await fetch('/api/dict/bc_status')
        if (statusResponse.ok) {
            const statuses = await statusResponse.json()
            const statusMap = new Map()
            statuses.forEach((it: any) => {
                statusMap.set(String(it.id), it.nameRu)
            })
            this.nameDict.status = statusMap
        } else {
            this.makeToast('Не получилось загрузить найменование статусов', 'Ошибка запроса', 'danger')
        }

        const statusColorMap = new Map()
        statusColorMap.set('1', 'text-green')
        statusColorMap.set('2', 'text-orange')
        statusColorMap.set('3', 'text-yellow')
        this.nameDict.statusColor = statusColorMap
    }

    private async setInitialFilterOptions() {
        const years: number[] = []
        const currentDate = new Date()
        const maxYear = currentDate.getFullYear() + 1
        const earliestYear: number = this.earliestYear ?? currentDate.getFullYear()
        for (let i = earliestYear; i <= maxYear; i++) {
            years.push(i)
        }
        this.filterOptions.years = years

        const budgetLevel: number | null = this.filterTempParameters.budgetLevel?.value ?? null

        this.filterOptions.quarters = cloneDeep(quarterOptions)
        this.filterOptions.agreementNumbers = await this.fetchAgreementNumberOptions(this.userId)
        this.filterOptions.budgetLevels = await this.fetchBudgetLevelOptions()
        this.filterOptions.creditors = await this.fetchCreditorOptions(budgetLevel)
        this.filterOptions.regions = await this.fetchRegionOptions(this.userId)
        this.filterOptions.administrators = await this.fetchAdministratorOptions(this.userId)
        this.filterOptions.contractors = await this.fetchContractorOptions(this.userId)
        this.filterOptions.statuses = await this.fetchStatusOptions()
        // this.filterOptions.currency = await this.fetchOptions('currency', 'теңге')
    }

    private async fetchAgreementNumberOptions(userId: string): Promise<Option<string>[]> {
        const response = await fetch(`/api/budget-loan/filtered?user-id=${userId}&contract-number=`)
        if (!response.ok) {
            this.makeToast('Не получилось загрузить варианты фильтров', 'Ошибка запроса', 'danger');
            return []
        }

        const data = await response.json()

        const getParentAgreement = (agreement: any): object | null => {
            if (agreement.mainAgreementId) {
                const parentOrBaseAgreement: object | null = data.find((it: any) => it.id === agreement.mainAgreementId) ?? null
                if (agreement.type === 0) { // is base agreement
                    const parentAgreement = parentOrBaseAgreement
                    return parentAgreement
                } else {
                    const baseAgreement = parentOrBaseAgreement
                    return getParentAgreement(baseAgreement)
                }
            } else {
                return null
            }
        }

        const options: Option<string>[] = data.map((it: any) => {
            let label: string = it.agreementNumber

            const parentAgreement = getParentAgreement(it)
            if (parentAgreement) {
                label = `${it.agreementNumber} (${(parentAgreement as any)?.agreementNumber})`
            }

            return {
                value: it.agreementNumber,
                label: label,
                additionalData: {
                    id: it.id
                }
            }
        })

        return options
    }

    private async fetchBudgetLevelOptions(): Promise<Option<number>[]> {
        const response = await fetch('/api/dict/dict_budget_level/pages')
        if (!response.ok) {
            this.makeToast('Не получилось загрузить варианты фильтров', 'Ошибка запроса', 'danger')
            return []
        }

        const pagedData = await response.json()
        const data: { id: number, name_ru: string }[] = pagedData.items
        const options: Option<number>[] = data
            .filter(it => [1, 2].includes(it.id))
            .map(it => {
                return {
                    value: it.id,
                    label: `${it.id} - ${it.name_ru}`
                }
            })

        return options
    }

    private async fetchCreditorOptions(budgetLevel: number | null): Promise<Option<string>[]> {
        if (budgetLevel == null) {
            return []
        }

        const strSignDate = moment().format('YYYY-MM-DD')
        const isRepublicanLevel = budgetLevel === 1

        let url = ''
        if (isRepublicanLevel) {
            url = '/api/budget-loan/options/creditors/republican'
        } else {
            if (strSignDate) {
                url = `/api/budget-loan/options/creditors/oblast?sign-date=${strSignDate}`
            } else {
                return []
            }
        }

        const response = await fetch(url)
        const responseData = await response.json()

        const creditorsOptions: Option<string>[] = responseData.map((it: any) => {
            let value = ''
            let label = ''
            if (isRepublicanLevel) {
                value = String(it.abp)
                label = `${it.abp} - ${it.nameRu}`
            } else {
                value = it.code
                label = `${it.code} - ${it.nameRu}`
            }

            return {
                label: label,
                value: value
            }
        })

        return creditorsOptions
    }

    private async fetchRegionOptions(userId: string): Promise<Option<string>[]> {
        const response = await fetch(`/api/dict/dict_budget_regions/user-management/${userId}`)
        if (!response.ok) {
            this.makeToast('Не удалось загрузить варианты фильтров', 'Ошибка запроса', 'danger')
            return []
        }

        const data = await response.json()
        const options: Option<string>[] = data.map((it: any) => {
            return {
                value: it.code,
                label: `${it.code} - ${it.nameRu}`
            }
        })
        options.unshift({ value: '000000', label: '000000' })

        const optionsMap = new Map<string, Option<string>>()
        options.forEach(option => {
            if (!optionsMap.has(option.value)) {
                optionsMap.set(option.value, option)
            }
        })
        const uniqueAndSortedOptions = Array.from(optionsMap.values()).sort((a, b) => a.value.localeCompare(b.value))

        return uniqueAndSortedOptions
    }

    private async fetchAdministratorOptions(userId: string): Promise<Option<string>[]> {
        const response = await fetch(`/api/dict/gu/administrator/filter/${userId}`)
        if (!response.ok) {
            this.makeToast('Не удалось загрузить варианты фильтров', 'Ошибка запроса', 'danger')
            return []
        }

        const data = await response.json()
        const options: Option<string>[] = data.map((it: any) => {
            return {
                value: it.code,
                label: `${it.code} - ${it.nameRu}`
            }
        })

        return options
    }

    private async fetchContractorOptions(userId: string): Promise<Option<string>[]> {
        const response = await fetch(`/api/dict/gu/contractor/filter/${userId}`)
        if (!response.ok) {
            this.makeToast('Не удалось загрузить варианты фильтров', 'Ошибка запроса', 'danger')
            return []
        }

        const data = await response.json()
        const options: Option<string>[] = data.map((it: any) => {
            return {
                value: it.code,
                label: `${it.code} - ${it.nameRu}`
            }
        })

        return options
    }

    private async fetchStatusOptions(): Promise<Option<number>[]> {
        const response = await fetch('api/dict/bc_status')
        if (!response.ok) {
            this.makeToast('Не удалось загрузить варианты фильтров', 'Ошибка запроса', 'danger')
            return []
        }

        const data = await response.json()
        const options: Option<number>[] = data.map((it: any) => {
            return {
                value: it.id,
                label: `${it.id} - ${it.nameRu}`
            }
        })

        return options
    }

    async setFilterParametersEmpty() {
        this.filterParameters = cloneDeep(emptyParameters)
        this.filterTempParameters = cloneDeep(emptyParameters)
    }

    async loadAgreementsFiltered() {
        this.loading = true
        const searchParams = this.filterParametersToSearchParams(cloneDeep(this.filterParameters), this.userId)
        const response = await fetch(`/api/budget-loan/filtered?${searchParams}`)
        if (!response.ok) {
            this.makeToast('Не получилось загрузить договоры', 'Ошибка запроса', 'danger');
            this.loading = false
            return
        }

        const agreements = await response.json()
        this.createTreeTableData(agreements)
        this.loading = false
    }

    private filterParametersToSearchParams(filterParameters: FilterParameters, userId: string): URLSearchParams {
        const searchParams = new URLSearchParams()

        if (filterParameters.agreementNumbers.length > 0 && filterParameters.agreementNumbers.length !== this.filterOptions.agreementNumbers.length) {
            filterParameters
                .agreementNumbers
                .map(it => it.value)
                .forEach(it => searchParams.append('agreement-numbers', it))
        }
        if (filterParameters.budgetLevel?.value) {
            searchParams.set('budget-level', filterParameters.budgetLevel.value.toString())
        }
        if (filterParameters.budgetLevel?.value) {
            searchParams.set('budget-level', filterParameters.budgetLevel.value.toString())
        }
        if (filterParameters.status?.value) {
            searchParams.set('status', filterParameters.status.value.toString())
        }
        if (filterParameters.contractor?.value) {
            searchParams.set('contractor', filterParameters.contractor.value)
        }
        if (filterParameters.quarter?.value) {
            searchParams.set('quarter', filterParameters.quarter.value.toString())
        }
        if (filterParameters.region?.value) {
            searchParams.set('region', filterParameters.region.value)
        }

        if (filterParameters.creditor?.value?.slice(-4) === '0000') {
            searchParams.set('creditor', filterParameters.creditor.value.substring(0, 3))
        } else if (filterParameters.creditor?.value) {
            searchParams.set('creditor', filterParameters.creditor.value)
        }

        if (filterParameters.administrator?.value?.slice(-4) === '0000') {
            searchParams.set('administrator', filterParameters.administrator.value.substring(0, 3))
        } else if (filterParameters.administrator?.value) {
            searchParams.set('administrator', filterParameters.administrator.value)
        }

        if (filterParameters.year) {
            searchParams.set('year', filterParameters.year.toString())
        }

        searchParams.set('user-id', userId)

        return searchParams
    }

    private createTreeTableData(flatData: Agreement[]) {
        // По направлениям кредита
        const loanDirectionMap = new Map<string, HierarchyAgreement[]>()
        for (const el of flatData) {
            let tmp = loanDirectionMap.get(String(el.loanDirection))
            if (tmp) {
                tmp.push(el)
            } else {
                tmp = [el]
            }
            loanDirectionMap.set(String(el.loanDirection), tmp)
        }

        // По целям кредита
        const loanDirectionAndPurposeMap = new Map<
            string,
            Map<string, HierarchyAgreement[]>
        >()
        for (const [key, value] of loanDirectionMap) {
            const loanPurposeMap = new Map<string, HierarchyAgreement[]>()
            for (const el of value) {
                let tmp = loanPurposeMap.get(el.loanPurpose)
                el.collapse = true
                if (tmp) {
                    tmp.push(el)
                } else {
                    tmp = [el]
                }
                loanPurposeMap.set(el.loanPurpose, tmp)
            }

            for (const [key, value] of loanPurposeMap) {
                for (const el of value) {
                    if (el.mainAgreementId) {
                        let childType
                        const parent = value.find((it: any) => {
                            childType = el.type
                            return el.mainAgreementId === it.id
                        })

                        if (parent != null) {
                            if (childType === 0) {
                                if (!parent.children) {
                                    parent.children = []
                                }
                                parent.children.push(el)
                            } else {
                                if (!parent.additionals) {
                                    parent.additionals = []
                                }
                                parent.additionals.push(el)
                            }
                            el.remove = true
                        }
                    }
                }

                const filtered = value.filter(item => !item.remove)
                loanPurposeMap.set(key, filtered)
            }

            loanDirectionAndPurposeMap.set(key, loanPurposeMap)
        }

        let id = 0
        // const resultArray = Array.from(resMap, ([name, value]) => ({ id: id++, name, collapse: true, loanDirection: name, children: value }))
        const resultArray: LoanDirectionNode[] = Array.from(loanDirectionAndPurposeMap, ([name, purposeMap]) => ({
            id: id++,
            name: Number(name),
            collapse: true,
            loanDirection: Number(name),
            children: [],
            tempAgreements: purposeMap,
            amount: 0,
            leftAmount: 0
        }))

        for (const item of resultArray) {
            const unsorted: LoanPurposeNode[] = Array.from(item.tempAgreements, ([name, agreements]) => ({
                id: id++,
                name: Number(name),
                collapse: true,
                loanPurpose: Number(name),
                children: agreements,
                amount: 0,
                leftAmount: 0
            }))
            item.children = unsorted.sort((a, b) => a.loanPurpose - b.loanPurpose)
        }

        for (const section of resultArray) {
            let sectionSum = 0
            let sectionLeftAmount = 0
            for (const goal of section.children) {
                let goalSum = 0
                let goalLeftAmount = 0
                for (const republicAgreement of goal.children) {
                    let agreementSum = 0
                    if (republicAgreement.additionals) {
                        agreementSum = republicAgreement.additionals.find(it => it.flagActual === 1)?.amount ?? 0
                    } else {
                        agreementSum = republicAgreement.amount ?? 0
                    }

                    goalSum += agreementSum
                    goalLeftAmount += republicAgreement.leftAmount ?? 0
                }
                goal.amount = goalSum
                goal.leftAmount = goalLeftAmount
                sectionSum += goalSum
                sectionLeftAmount += goalLeftAmount
            }
            section.amount = sectionSum
            section.leftAmount = sectionLeftAmount
        }

        this.tableData = resultArray
    }

    public tableCollapse(
        loanDirectionIndex: number | null,
        loanPurposeIndex: number | null,
        higherLevelLoanIndex: number | null,
        collapse: boolean
    ) {
        if (loanDirectionIndex === null) {
            this.collapseAll = !this.collapseAll
            for (const item of this.tableData) {
                item.collapse = this.collapseAll
                for (const subItem of item.children) {
                    if (subItem.collapse !== null) {
                        subItem.collapse = this.collapseAll
                        for (const subSubItem of subItem.children) {
                            subSubItem.collapse = this.collapseAll
                        }
                    }
                }
            }
            return
        }
        if (loanPurposeIndex === null) {
            this.tableData[loanDirectionIndex].collapse = collapse
            for (const item of this.tableData[loanDirectionIndex].children) {
                if (item.collapse !== null) {
                    item.collapse = true
                    for (const subItem of item.children) {
                        if (subItem.collapse !== null) {
                            subItem.collapse = collapse
                        }
                    }
                }
            }
        } else if (higherLevelLoanIndex === null) {
            if (this.tableData[loanDirectionIndex].children[loanPurposeIndex].collapse !== null) {
                this.tableData[loanDirectionIndex].children[loanPurposeIndex].collapse = collapse
            }
        } else {
            if (this.tableData[loanDirectionIndex].children[loanPurposeIndex].children[higherLevelLoanIndex].collapse !== null) {
                this.tableData[loanDirectionIndex].children[loanPurposeIndex].children[higherLevelLoanIndex].collapse = collapse
            }
        }
    }

    public retrieveErrorCode(agreement: HierarchyAgreement) {
        let errorBetweenAgreements = false
        let errorSchedule = false

        if (agreement.flagError === 1) {
            errorBetweenAgreements = true
        } else if (agreement.flagError === 2) {
            errorSchedule = true
        }

        if (agreement.additionals) {
            agreement.additionals.forEach(item => {
                if (item.flagError === 1) {
                    errorBetweenAgreements = true
                } else if (item.flagError === 2) {
                    errorSchedule = true
                }
            })
        }

        if (errorBetweenAgreements && errorSchedule) {
            return 3
        } else if (errorBetweenAgreements) {
            return 1
        } else if (errorSchedule) {
            return 2
        }
        return 0
    }

    public formatDigitReadability(value: number | string) {
        if (!value && value !== 0) {
            return '-'
        }
        let temp = String(value)
        const removedSpaceString = temp.replace(/\s/g, "")
        temp = removedSpaceString.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        return temp
    }

    public handleOpenAgreement(agreementId: number, mode: string) {
        const params: Record<string, string> = { id: agreementId.toString(), mode: mode }
        if (!this.isFilterEmpty(this.filterParameters)) {
            const tableQuery = JSON.stringify(this.filterParameters)
            params.tableQuery = tableQuery
        }

        this.$router.push({
            name: 'budget-loan-form',
            params: params
        })
    }

    private isFilterEmpty(filterParameters: FilterParameters) {
        let isEmpty = true
        Object.keys(filterParameters).forEach(key => {
            const typedKey = key as keyof FilterParameters
            if (filterParameters[typedKey] != null) {
                isEmpty = false
            }
        })

        return isEmpty
    }

    async handleAgreementDeletion(agreementId: number) {
        const response = await fetch(`api/budget-loan/validate-deletion/${agreementId}`)
        if (!response.ok) {
            const message = (await response.json())?.args[0]?.value[0]
            this.makeToast(message, 'Ошибка', 'danger')
            return
        }

        this.$bvModal.msgBoxConfirm(
            'После удаления данные не подлежать восстановлению. Вы уверены?',
            {
                title: 'Подтверждение',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Удалить',
                cancelTitle: 'Отмена',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(confirmed => {
                if (confirmed) {
                    this.deleteAgreement(agreementId)
                }
            })
            .catch(error => {
                this.makeToast('Не удалось удалить договор', 'Ошибка удаления', 'danger')
                console.error(error.toString())
            })
    }

    async deleteAgreement(agreementId: number) { // TODO: account new load method with url params
        const response = await fetch(`/api/budget-loan/${agreementId}`, { method: 'DELETE' })
        if (!response.ok) {
            const message = (await response.json())?.args[0]?.value[0]
            this.makeToast(message, 'Ошибка', 'danger')
            return
        }
        this.makeToast('Успешно удалено', 'Сообщение', 'success')

        // Перезагрузить реестр
        this.loading = true
        const agreementsResponse = await fetch('/api/budget-loan')
        if (!agreementsResponse.ok) {
            this.makeToast('Не получилось загрузить договоры', 'Ошибка запроса', 'danger');
            return
        }
        const agreements = await agreementsResponse.json()
        this.createTreeTableData(agreements)
        await this.loadAgreementsAndSetNameMappings()
        await this.loadValueNames()
        await this.setInitialFilterOptions()
        await this.setFilterParametersEmpty()
        this.loading = false
    }

    public async downloadInstruction() {
        this.loading = true
        Ax(
            {
                url: '/api/budget-loan/files/storage-download/Инструкция_Бюджетные кредиты.pdf',
                method: 'GET',
                responseType: 'blob'
            },
            (data: BlobPart) => {
                // Загрузка файла
                const blob = new Blob([data])
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                const filename = 'Инструкция Бюджетные кредиты'
                const extension = '.pdf'
                link.setAttribute('download', filename + extension)
                document.body.appendChild(link)
                link.click()
                // Cleanup
                document.body.removeChild(link)
                this.loading = false
                window.URL.revokeObjectURL(url)
            },
            (error) => {
                this.makeToast('Ошибка', 'Произошла ошибка при скачиваний', 'danger')
                this.loading = false
            }
        )
    }

    public handleCloseFilter() {
        this.filterTempParameters = cloneDeep(this.filterParameters)
        // @ts-ignore
        this.$refs.drop.hide(true)
    }

    public async onBudgetLevelChange(option: Option<number> | null) {
        const budgetLevel: number | null = option?.value ?? null
        this.filterTempParameters.creditor = null
        this.filterOptions.creditors = []
        this.filterOptions.creditors = await this.fetchCreditorOptions(budgetLevel)
    }

    public toDDMMYYYY(value: Date | number | string | null | undefined): string | null {
        if (!value) {
            return null
        }

        const formatted: string = moment(value).format('DD-MM-YYYY')
        return formatted
    }

    public async calculateEveryAgreementActualityFlag() {
        const response = await fetch('api/budget-loan/agreements/assign-actuality-status', {
            method: 'PUT'
        })
        if (response.ok) {
            this.makeToast('Перерасчет исполнен', 'Сообщение', 'success')
        } else {
            this.makeToast('Ошибка перерасчета', 'Ошибка', 'danger')
        }
    }

    public async calculateEveryAgreementRegionCode() {
        const response = await fetch('api/budget-loan/calculate-every-agreement-region-code', {
            method: 'PUT'
        })
        if (response.ok) {
            this.makeToast('Перерасчет исполнен', 'Сообщение', 'success')
        } else {
            this.makeToast('Ошибка перерасчета', 'Ошибка', 'danger')
        }
    }

    public async setInitialInterestDateEveryAgreement() {
        const response = await fetch('api/budget-loan-schedule/set-initial-interest-date-every-agreement', {
            method: 'PUT'
        })
        if (response.ok) {
            this.makeToast('Даты проставлены', 'Сообщение', 'success')
        } else {
            this.makeToast('Ошибка перерасчета', 'Ошибка', 'danger')
        }
    }

    public async calculateEveryAgreementLeftAmount() {
        const response = await fetch('api/budget-loan-schedule/calculate-every-agreement-left-amount', {
            method: 'PUT'
        })
        if (response.ok) {
            this.makeToast('Перерасчет исполнен', 'Сообщение', 'success')
        } else {
            this.makeToast('Ошибка перерасчета', 'Ошибка', 'danger')
        }
    }

    public async recalculateForecastInEveryForecastPresentAgreement() {
        const response = await fetch(
            'api/budget-loan-schedule/recalculate-forecast-in-every-forecast-present-agreement',
            { method: 'PUT' }
        )
        if (response.ok) {
            this.makeToast('Перерасчет исполнен', 'Сообщение', 'success')
        } else {
            this.makeToast('Ошибка перерасчета', 'Ошибка', 'danger')
        }
    }
    // #endregion

    // #region Report Generations

    public async generate130Report() {
        let valid = true
        if (this.filterTempParameters.year == null) {
            this.makeToast('Необходимо указать год в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (this.filterTempParameters.quarter == null) {
            this.makeToast('Необходимо указать квартал в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (this.filterTempParameters.creditor == null) {
            this.makeToast('Необходимо указать кредитора в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (!valid) {
            return
        }

        const creditorCode = this.filterTempParameters.creditor?.value
        const quarter = this.filterTempParameters.quarter?.value
        const year = this.filterTempParameters.year
        if (creditorCode == null || quarter == null || year == null) {
            throw new Error('')
        }

        const params: Record<string, string> = {}
        params['quarter'] = quarter.toString()
        params['year'] = year.toString()
        params['locale'] = i18nService.locale
        if (this.filterTempParameters.region?.value) {
            params['region-code'] = this.filterTempParameters.region.value
        }
        if (creditorCode.slice(-4) !== '0000') {
            params['abp-code'] = creditorCode.substring(0, 3)
            params['org-code'] = creditorCode
        } else {
            params['org-code'] = creditorCode.substring(0, 3)
        }

        const queryString = new URLSearchParams(params).toString()
        this.loading = true
        await Ax(
            {
                url: `/api/budget-loan-reports/130?${queryString}`,
                method: 'GET',
                responseType: 'blob'
            },
            (data: BlobPart) => {
                // Загрузка файла
                const blob = new Blob([data])
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Отчет 130.xlsx')
                document.body.appendChild(link)
                link.click()
                // Cleanup
                document.body.removeChild(link)
                this.loading = false
                window.URL.revokeObjectURL(url)
            },
            (error) => {
                this.makeToast('Не удалось сформировать отчет', 'Ошибка', 'danger')
                this.loading = false
            }
        )
    }

    public async generateRegisterReport() {
        this.loading = true
        const searchParams = this.getFilterSearchParams()
        await Ax(
            {
                url: `/api/budget-loan-reports/register?${searchParams}`,
                method: 'GET',
                responseType: 'blob'
            },
            (data: BlobPart) => {
                // Загрузка файла
                const blob = new Blob([data])
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Реестр бюджетных кредитов.xlsx')
                document.body.appendChild(link)
                link.click()
                // Cleanup
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)
                this.loading = false
            },
            (error) => {
                this.makeToast('Не удалось сформировать отчет', 'Ошибка', 'danger')
                this.loading = false
            }
        )
    }

    public async generateRegisterReport2() {
        this.loading = true
        const searchParams = this.getFilterSearchParams()
        const filterLabels = this.getFilterKeyToLabelMap()
        searchParams.set('filter-labels', JSON.stringify(filterLabels))
        await Ax(
            {
                url: `/api/budget-loan-reports/register-2?${searchParams}`,
                method: 'GET',
                responseType: 'blob'
            },
            (data: BlobPart) => {
                // Загрузка файла
                const blob = new Blob([data])
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Реестр бюджетных кредитов (приложение 2).xlsx')
                document.body.appendChild(link)
                link.click()
                // Cleanup
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)
                this.loading = false
            },
            (error) => {
                this.makeToast('Не удалось сформировать отчет', 'Ошибка', 'danger')
                this.loading = false
            }
        )
    }

    public async generateRegisterReport3() {
        this.loading = true
        const searchParams = this.getFilterSearchParams()
        const filterLabels = this.getFilterKeyToLabelMap()
        searchParams.set('filter-labels', JSON.stringify(filterLabels))
        await Ax(
            {
                url: `/api/budget-loan-reports/register-3?${searchParams}`,
                method: 'GET',
                responseType: 'blob'
            },
            (data: BlobPart) => {
                // Загрузка файла
                const blob = new Blob([data])
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Реестр в разрезе заемщиков (Приложение 1).xlsx')
                document.body.appendChild(link)
                link.click()
                // Cleanup
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)
                this.loading = false
            },
            (error) => {
                this.makeToast('Не удалось сформировать отчет', 'Ошибка', 'danger')
                this.loading = false
            }
        )
    }

    public async generate131Report() {
        let valid = true
        if (this.filterTempParameters.year == null) {
            this.makeToast('Необходимо указать год в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (this.filterTempParameters.quarter == null) {
            this.makeToast('Необходимо указать квартал в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (this.filterTempParameters.creditor == null) {
            this.makeToast('Необходимо указать кредитора в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (!valid) {
            return
        }

        const creditorCode = this.filterTempParameters.creditor?.value
        const quarter = this.filterTempParameters.quarter?.value
        const year = this.filterTempParameters.year
        if (creditorCode == null || quarter == null || year == null) {
            throw new Error('')
        }

        this.loading = true

        const params: Record<string, string> = {}
        params['quarter'] = quarter.toString()
        params['year'] = year.toString()
        if (this.filterTempParameters.region?.value) {
            params['region-code'] = this.filterTempParameters.region.value
        }
        if (creditorCode.slice(-4) !== '0000') {
            params['abp-code'] = creditorCode.substring(0, 3)
            params['org-code'] = creditorCode
        } else {
            params['org-code'] = creditorCode.substring(0, 3)
        }
        params['locale'] = i18nService.locale
        const queryString = new URLSearchParams(params)

        await Ax(
            {
                url: `/api/budget-loan-reports/131?${queryString}`,
                method: 'GET',
                responseType: 'blob'
            },
            (data: BlobPart) => {
                // Загрузка файла
                const blob = new Blob([data])
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                const filename = 'Отчет 131'
                const extension = '.xlsx'
                link.setAttribute('download', filename + extension)
                document.body.appendChild(link)
                link.click()
                // Cleanup
                document.body.removeChild(link)
                this.loading = false
                window.URL.revokeObjectURL(url)
            },
            (error) => {
                this.makeToast('Не удалось сформировать отчет', 'Ошибка', 'danger')
                this.loading = false
            }
        )
    }

    public async generate016Report() {
        let valid = true
        if (this.filterTempParameters.year == null) {
            this.makeToast('Необходимо указать год в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (this.filterTempParameters.quarter == null) {
            this.makeToast('Необходимо указать квартал в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (this.filterTempParameters.creditor == null) {
            this.makeToast('Необходимо указать кредитора в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (!valid) {
            return
        }

        const creditorCode = this.filterTempParameters.creditor?.value
        const quarter = this.filterTempParameters.quarter?.value
        const year = this.filterTempParameters.year
        if (creditorCode == null || quarter == null || year == null) {
            throw new Error('')
        }

        const params: Record<string, string> = {}
        params['userId'] = this.userId
        params['quarter'] = quarter.toString()
        params['year'] = year.toString()
        if (this.filterTempParameters.region?.value) {
            params['region-code'] = this.filterTempParameters.region.value
        }
        if (creditorCode.slice(-4) !== '0000') {
            params['abp-code'] = creditorCode.substring(0, 3)
            params['org-code'] = creditorCode
        } else {
            params['org-code'] = creditorCode.substring(0, 3)
        }
        const queryString = new URLSearchParams(params)

        this.loading = true
        try {
            const response = await fetch(`/api/budget-loan-reports/016?${queryString}`)
            if (!response.ok) {
                const errorResponse = await response.json()
                const message = errorResponse?.args[0]?.value[0]
                this.makeToast(message, 'Ошибка', 'danger')
            }
            const blob = await response.blob()
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            const filename = `Прогноз по БП - 016 на ${params.year}г.`
            const extension = '.xlsx'
            link.href = url
            link.setAttribute('download', filename + extension)
            document.body.appendChild(link)
            link.click()
            // Cleanup
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        } catch (error) {
        } finally {
            this.loading = false
        }
    }

    public async generatePrincipalRepaymentReport() {
        let valid = true
        if (this.filterTempParameters.year == null) {
            this.makeToast('Необходимо указать год в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (this.filterTempParameters.creditor == null) {
            this.makeToast('Необходимо указать кредитора в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (!valid) {
            return
        }

        const creditorCode = this.filterTempParameters.creditor?.value
        const year = this.filterTempParameters.year
        if (creditorCode == null || year == null) {
            throw new Error('')
        }

        const params: Record<string, string> = {}
        params['userId'] = this.userId
        params['year'] = year.toString()
        if (this.filterTempParameters.region?.value) {
            params['region-code'] = this.filterTempParameters.region.value
        }
        if (creditorCode.slice(-4) !== '0000') {
            params['abp-code'] = creditorCode.substring(0, 3)
            params['org-code'] = creditorCode
        } else {
            params['org-code'] = creditorCode.substring(0, 3)
        }
        const queryString = new URLSearchParams(params)

        this.loading = true
        await Ax(
            {
                url: `/api/budget-loan-reports/principal-repayment?${queryString}`,
                method: 'GET',
                responseType: 'blob'
            },
            (data: BlobPart) => {
                // Загрузка файла
                const blob = new Blob([data])
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                const filename = `Отчет Погашение осн. долга по кредитам сельс. спец. на ${params.year}-${Number(params.year) + 2} гг.`
                const extension = '.xlsx'
                link.setAttribute('download', filename + extension)
                document.body.appendChild(link)
                link.click()
                // Cleanup
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)
                this.loading = false
            },
            (error) => {
                this.makeToast('Не удалось сформировать отчет', 'Ошибка', 'danger')
                this.loading = false
            }
        )
    }

    public async generate015Report() {
        let valid = true
        if (this.filterTempParameters.year == null) {
            this.makeToast('Необходимо указать год в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (this.filterTempParameters.quarter == null) {
            this.makeToast('Необходимо указать квартал в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (this.filterTempParameters.creditor == null) {
            this.makeToast('Необходимо указать кредитора в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (!valid) {
            return
        }

        const creditorCode = this.filterTempParameters.creditor?.value
        const quarter = this.filterTempParameters.quarter?.value
        const year = this.filterTempParameters.year
        if (creditorCode == null || quarter == null || year == null) {
            throw new Error('')
        }

        const params: Record<string, string> = {}
        params['userId'] = this.userId
        params['quarter'] = quarter.toString()
        params['year'] = year.toString()
        if (this.filterTempParameters.region?.value) {
            params['region-code'] = this.filterTempParameters.region.value
        }
        if (creditorCode.slice(-4) !== '0000') {
            params['abp-code'] = creditorCode.substring(0, 3)
            params['org-code'] = creditorCode
        } else {
            params['org-code'] = creditorCode.substring(0, 3)
        }
        const queryString = new URLSearchParams(params)

        this.loading = true
        try {
            const response = await fetch(`/api/budget-loan-reports/015?${queryString}`);
            if (!response.ok) {
                const errorResponse = await response.json()
                const message = errorResponse?.args[0]?.value[0]
                this.makeToast(message, 'Ошибка', 'danger')
                throw new Error()
            }
            const blob = await response.blob()
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            const filename = `Прогноз по БП - 015 на ${params.year}г.`
            const extension = '.xlsx';
            link.href = url;
            link.setAttribute('download', filename + extension)
            document.body.appendChild(link)
            link.click()

            // Cleanup
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        } catch (error) {
        } finally {
            this.loading = false
        }
    }

    public async generate3Report() {
        let valid = true
        if (this.filterTempParameters.year == null) {
            this.makeToast('Необходимо указать год в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (this.filterTempParameters.quarter == null) {
            this.makeToast('Необходимо указать квартал в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (this.filterTempParameters.creditor == null) {
            this.makeToast('Необходимо указать кредитора в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (!valid) {
            return
        }

        const creditorCode = this.filterTempParameters.creditor?.value
        const quarter = this.filterTempParameters.quarter?.value
        const year = this.filterTempParameters.year
        if (creditorCode == null || quarter == null || year == null) {
            throw new Error('')
        }

        const params: Record<string, string> = {}
        params['userId'] = this.userId
        params['quarter'] = quarter.toString()
        params['year'] = year.toString()
        if (this.filterTempParameters.region?.value) {
            params['region-code'] = this.filterTempParameters.region.value
        }
        if (creditorCode.slice(-4) !== '0000') {
            params['abp-code'] = creditorCode.substring(0, 3)
            params['org-code'] = creditorCode
        } else {
            params['org-code'] = creditorCode.substring(0, 3)
        }

        const queryString = new URLSearchParams(params)

        this.loading = true
        try {
            const response = await fetch(`/api/budget-loan-reports/3?${queryString}`)
            if (!response.ok) {
                const errorResponse = await response.json()
                const message = errorResponse?.args[0]?.value[0]
                this.makeToast(message, 'Ошибка', 'danger')
            }
            const blob = await response.blob()
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            const filename = `Приложение 3 на ${params.year} г.`
            const extension = '.xlsx'
            link.href = url
            link.setAttribute('download', filename + extension)
            document.body.appendChild(link)
            link.click()

            // Cleanup
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        } catch (error) {
        } finally {
            this.loading = false
        }
    }

    public async generatePlan1Or2Report(budgetLevel: number) {
        let valid = true
        if (this.filterTempParameters.year == null) {
            this.makeToast('Необходимо указать год в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (this.filterTempParameters.creditor == null) {
            this.makeToast('Необходимо указать кредитора в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (!valid) {
            return
        }

        const creditorCode = this.filterTempParameters.creditor?.value
        const year = this.filterTempParameters.year
        if (creditorCode == null || year == null) {
            throw new Error('')
        }

        const params: Record<string, string> = {}
        params['budget-level'] = budgetLevel.toString()
        params['userId'] = this.userId
        params['year'] = year.toString()
        if (this.filterTempParameters.region?.value) {
            params['region-code'] = this.filterTempParameters.region.value
        }
        if (creditorCode.slice(-4) !== '0000') {
            params['abp-code'] = creditorCode.substring(0, 3)
            params['org-code'] = creditorCode
        } else {
            params['org-code'] = creditorCode.substring(0, 3)
        }
        const queryString = new URLSearchParams(params)

        this.loading = true
        try {
            const response = await fetch(`/api/budget-loan-reports/plan-1-or-2?${queryString}`)
            if (!response.ok) {
                const errorResponse = await response.json()
                const message = errorResponse?.args[0]?.value[0]
                this.makeToast(message, 'Ошибка', 'danger')
            }
            const blob = await response.blob()
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            const currentDate = new Date()
            const year = currentDate.getFullYear()
            let month: string = (currentDate.getMonth() + 1).toString()
            let day: string = (currentDate.getDate() + 1).toString()
            month = Number(month) < 10 ? '0' + month : month
            day = Number(day) < 10 ? '0' + day : day
            const filename = `План_${budgetLevel}_ур_помесяч_на ${params.year} год на_${day}_${month}_${year}_`
            const extension = '.xlsx'
            link.href = url
            link.setAttribute('download', filename + extension)
            document.body.appendChild(link)
            link.click()
            // Cleanup
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        } catch (error) {
        } finally {
            this.loading = false
        }
    }

    public async generateAccountingCardReport() {
        if (this.filterTempParameters.contractor == null) {
            this.makeToast('Необходимо указать заемщика в фильтре', 'Сообщение', 'danger')
            return
        }

        this.loading = true
        const searchParams = this.getFilterSearchParams()
        await Ax(
            {
                url: `/api/budget-loan-reports/accounting-card?${searchParams}`,
                method: 'GET',
                responseType: 'blob'
            },
            (data: BlobPart) => {
                // Загрузка файла
                const blob = new Blob([data])
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Карточка учета бюджетных кредитов (Приложение 2).xlsx')
                document.body.appendChild(link)
                link.click()
                // Cleanup
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)
                this.loading = false
            },
            (error) => {
                this.makeToast('Не удалось сформировать отчет', 'Ошибка', 'danger')
                this.loading = false
            }
        )
    }

    public async generateApplication3() {
        let valid = true
        if (this.filterTempParameters.agreementNumbers.length === 0) {
            this.makeToast('Необходимо указать договор в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (this.filterTempParameters.year == null) {
            this.makeToast('Необходимо указать год в фильтре', 'Сообщение', 'danger')
            valid = false
        }
        if (!valid) {
            return
        }

        this.loading = true

        const requestBody: Record<string, (number | number[] | string | null)> = {}
        const agreementIds: number[] = []
        this.filterTempParameters.agreementNumbers.forEach(it => {
            agreementIds.push(it.additionalData.id)
        })
        requestBody['agreementIds'] = agreementIds
        if (this.filterTempParameters.year) {
            requestBody['year'] = this.filterTempParameters.year
        }
        if (this.filterTempParameters.quarter) {
            requestBody['quarter'] = this.filterTempParameters.quarter.value
        }
        if (this.filterTempParameters.budgetLevel) {
            requestBody['budgetLevel'] = this.filterTempParameters.budgetLevel.value
        }
        if (this.filterTempParameters.creditor) {
            requestBody['creditor'] = this.filterTempParameters.creditor.value
        }
        if (this.filterTempParameters.contractor) {
            requestBody['contractor'] = this.filterTempParameters.contractor.value
        }
        if (this.filterTempParameters.status) {
            requestBody['status'] = this.filterTempParameters.status.value
        }
        if (this.filterTempParameters.administrator) {
            requestBody['administrator'] = this.filterTempParameters.administrator.value
        }
        if (this.filterTempParameters.region) {
            requestBody['region'] = this.filterTempParameters.region.value
        }

        const filterLabels = this.getFilterKeyToLabelMap()
        requestBody['filterLabels'] = JSON.stringify(filterLabels)

        try {
            const response = await fetch(`/api/budget-loan-reports/application-3`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody)
            })
            if (!response.ok) {
                let message = 'Не удалось сформировать отчет'
                const errorResponse = await response.json()
                if (errorResponse?.key) {
                    message = errorResponse?.key
                }
                this.makeToast(message, 'Ошибка', 'danger')
                throw new Error('')
            }
            const blob = await response.blob()
            if (blob.size === 0) {
                this.makeToast('Отсутствуют данные', 'Сообщение', 'info')
                return
            }
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            const filename = `Приложение 3`
            const extension = '.xlsx'
            link.href = url
            link.setAttribute('download', filename + extension)
            document.body.appendChild(link)
            link.click()
            // Cleanup
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        } catch (error) {
        } finally {
            this.loading = false
        }
    }

    private getFilterSearchParams(): URLSearchParams {
        const searchParams = new URLSearchParams()

        if (this.filterTempParameters.agreementNumbers.length > 0 && this.filterTempParameters.agreementNumbers.length !== this.filterOptions.agreementNumbers.length) {
            this.filterTempParameters
                .agreementNumbers
                .map(it => it.value)
                .forEach(it => searchParams.append('agreement-numbers', it))
        }

        if (this.filterTempParameters.budgetLevel?.value) {
            searchParams.set('budget-level', this.filterTempParameters.budgetLevel.value.toString())
        }
        if (this.filterTempParameters.status?.value) {
            searchParams.set('status', this.filterTempParameters.status.value.toString())
        }
        if (this.filterTempParameters.contractor?.value) {
            searchParams.set('contractor', this.filterTempParameters.contractor.value.toString())
        }
        if (this.filterTempParameters.quarter?.value) {
            searchParams.set('quarter', this.filterTempParameters.quarter.value.toString())
        }
        if (this.filterTempParameters.region?.value) {
            searchParams.set('region', this.filterTempParameters.region.value)
        }
        if (this.filterTempParameters.year) {
            searchParams.set('year', this.filterTempParameters.year.toString())
        }
        if (this.filterTempParameters.administrator?.value) {
            searchParams.set('administrator', this.filterTempParameters.administrator.value)
        }
        if (this.filterTempParameters.creditor?.value) {
            searchParams.set('creditor', this.filterTempParameters.creditor.value)
        }

        if (searchParams.get('budget-level') === '1') {
            if (this.filterTempParameters.administrator?.value) {
                searchParams.set('administrator', this.filterTempParameters.administrator.value.substring(0, 3))
            }
            if (this.filterTempParameters.creditor?.value) {
                searchParams.set('creditor', this.filterTempParameters.creditor.value.substring(0, 3))
            }
        }

        return searchParams
    }

    private getFilterKeyToLabelMap() {
        const map: Record<string, string> = {}
        for (const key in this.filterTempParameters) {
            if (this.filterTempParameters.hasOwnProperty(key)) { // Check if the key is the object's own property
                const typedKey = (key as keyof FilterParameters)
                if (typedKey === 'year') {
                    map[typedKey] = this.filterTempParameters.year?.toString() ?? 'Все'
                } else if (typedKey === 'agreementNumbers') {
                    if (this.filterTempParameters[typedKey].length === 0 || this.filterTempParameters[typedKey].length === this.filterOptions.agreementNumbers.length) {
                        map[typedKey] = 'Все'
                    } else {
                        map[typedKey] = this.filterTempParameters[typedKey]
                            .map(it => it.label)
                            .join(', ')
                    }
                } else if (typeof this.filterTempParameters[typedKey] === 'object') {
                    map[typedKey] = this.filterTempParameters[typedKey]?.label ?? 'Все'
                }
            }
        }
        return map
    }

    public openFilterByRef(refName: string) {
        const drop = this.$refs.drop!
        // @ts-ignore
        drop.show(true)
        const refItem = this.$refs[refName]
        // @ts-ignore
        setTimeout(() => refItem.$el.focus(), 100)
    }


    public onApplyFilters() {
        this.filterParameters = cloneDeep(this.filterTempParameters)
        this.loadAgreementsFiltered()
        // @ts-ignore
        this.$refs.drop.hide(true)
    }

    public async handleDropFilterParameters() {
        this.filterTempParameters = cloneDeep(emptyParameters)
        this.filterParameters = cloneDeep(emptyParameters)
        await this.loadAgreementsFiltered()
    }
    // #endregion

    public openSendNotificationModal() {
        this.notificationForm = {
            date: new Date(),
            receivers: []
        }
        this.notificationFormModalVisibility = true
    }

    public async sendRepaymentNotifications() {
        const dateStr = moment(this.notificationForm.date).format('YYYY-MM-DD')
        const requestBody = {
            date: dateStr,
            receivers: this.notificationForm.receivers.map(it => it.value)
        }

        this.notificationProcessloading = true
        const response = await fetch('/api/budget-loan-schedule/repayment-notifications', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody)
        })
        this.notificationProcessloading = false

        if (response.ok) {
            this.makeToast('Отправлены уведомления', 'Сообщение', 'success')
        } else {
            this.makeToast('Возникла ошибка при обработке', 'Ошибка', 'danger')
        }
    }
}
